// src/pages/MembershipBenefits.js
import React from "react";
import "./MembershipBenefits.css";

const benefits = [
  "Representation in engagement and advocacy with National and County Governments on matters affecting LiRRA members on urban planning, security and safety, environment, pollution control, infrastructure and access to services.",
  "Protection of our land use policies and zoning through LiRRA’s engagement with Kikuyu Municipality and County Assembly of Kiambu.",
  "A WhatsApp group to get firsthand information and report any concerns on matters of security, safety, environment and infrastructure.",
  "Benefit from Link Road Resident Association’s Environmental Policy and Plan, including clean ups, beautification, tree planting on road reserves, air monitoring, water assessments and focus on zero pollution.",
  "Benefit from Link Road Residents Association’s Security Plan, including access to security information, collaboration and linkage with security actors.",
  "LiRRA’s welfare policy that will incorporate the needs of Members, Elderly, Youth and Children in our neighbourhood.",
  "Collaboration with LiRRA members on legal and administrative matters of common interest within the Association mandate.",
  "Marketing opportunities, including weekly market day in our WhatsApp group.",
  "Access to negotiated offers and discounts, such as supermarkets, clubs, restaurants, furniture shops, and sports facilities.",
  "A platform where Corporate Members can channel messaging and undertake collaborative activities or projects for the betterment of the neighbourhood environment, security, infrastructure, or members’ welfare.",
  "Participation in charity initiatives.",
  "Participation in tailored training for Members and extended audiences.",
  "Access to a Service Learning program for Members’ children/students to participate in LiRRA community activities and receive a certificate showing tasks and hours completed.",
  "Participation in the LiRRA Committees' Annual General Meetings to shape a neighbourhood worth our stay."
];

export default function MembershipBenefits() {
  return (
    <div className="membership-page">
      <div className="membership-hero">
        <div className="membership-hero-content">
          <span className="membership-badge">Link Road Residents Association</span>
          <h1>Membership Benefits</h1>
          <p>
            Discover the benefits available to Link Road Residents Association members
            and see the value of being part of the community.
          </p>
        </div>
      </div>

      <div className="membership-container">
        <div className="membership-intro-card">
          <h2>Why become a member?</h2>
          <p>
            LiRRA membership gives residents a stronger collective voice on planning,
            security, environment, infrastructure, welfare, and community development.
          </p>
        </div>

        <div className="membership-benefits-grid">
          {benefits.map((benefit, index) => (
            <div className="membership-benefit-card" key={index}>
              <div className="membership-benefit-number">{index + 1}</div>
              <p>{benefit}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}